import Vue from 'vue';

import App from './App.vue';
import vuetify from './plugins/vuetify';
import toastification from './plugins/toastification';
import router from './router';
import store from './store';

import '@babel/polyfill';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';

import 'element-tiptap/lib/index.css';

Vue.config.productionTip = false;

new Vue({
  toastification,
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
